import React from 'react';

import { useLateResponsesReportCsv } from 'api';
import { useLateResponseFilters } from './hooks';
import { MobileReportModal } from '../..';

export const LateResponsesReportMobile: React.FC = () => {
  const filters = useLateResponseFilters();
  const { mutate: exportCsv } = useLateResponsesReportCsv();

  return <MobileReportModal filters={filters} exportCsv={exportCsv} />;
};
